module.exports = __webpack_public_path__ + "media/components/src/assets/images/tables/block_table_5-15e3aa0f5897fe7e9abf67687e1eaedb.jpg";